<template>
  <div class="home-container">
    <!-- <div class="background-slider">
      <div v-for="(slide, index) in slides" :key="index" 
           class="slide" 
           :class="{ active: currentSlide === index }"
           :style="{ backgroundImage: `url(${slide.image})` }">
      </div>
    </div> -->
    <div class="video-background">
      <!-- <video autoplay loop muted playsinline>
        <source src="../assets/videos/hk_bay.mp4" type="video/mp4">
      </video> -->
      <div v-for="(video, index) in videos" :key="index"
           class="video-slide"
           :class="{ active: currentVideo === index }">
        <video autoplay loop muted playsinline>
          <source :src="video.source" :type="video.type">
        </video>
      </div>
    </div>
    
    <div class="content-container">
      <div class="text-center">
        <h1>On-site Experiences, Virtual Sessions,<br>Webinars, Live Learning Events</h1>
        <p>
          Whether you're studying for the SAT, GRE, or another big exam, learn<br>
          the words you're most likely to encounter on test day. We'll evaluate you<br>
          with a test to gauge your language proficiency and pinpoint areas for<br>
          improvement.
        </p>
        <button class="btn btn-primary btn-lg" @click="openContactForm">Start Learning</button>
      </div>
    </div>
    
    <ContactFormModal ref="contactFormModal" />
  </div>
</template>

<script>
import ContactFormModal from '@/components/ContactFormModal.vue'

export default {
  components: {
    ContactFormModal
  },
  name: 'Home',
  data() {
    return {
      // currentSlide: 0,
      // slides: [
      //   { image: require('../assets/images/background1.jpg') },
      //   { image: require('../assets/images/background2.jpg') },
      //   { image: require('../assets/images/background3.jpg') }
      // ],
      currentVideo: 0,
      videos: [
        { 
          source: 'http://resources.generalwrite.com/forest20s_small.mp4',
          type: 'video/mp4'
        },
        { 
          source: 'http://resources.generalwrite.com/hk30s_mid.mp4',
          type: 'video/mp4'
        }
      ]
    }
  },
  mounted() {
    this.startVideoSlideshow(); // 修改为新的方法名
  },
  methods: {
    startVideoSlideshow() { // 新的视频轮播方法
      setInterval(() => {
        this.currentVideo = (this.currentVideo + 1) % this.videos.length;
      }, 10000); // 每20秒切换一次视频
    },
    openContactForm() {
      this.$refs.contactFormModal.show();
    }
  }
  // mounted() {
  //   this.startSlideshow();
  // },
  // methods: {
  //   startSlideshow() {
  //     setInterval(() => {
  //       this.currentSlide = (this.currentSlide + 1) % this.slides.length;
  //     }, 20000);
  //   }
  // }
}
</script>

<style scoped>
.home-container {
  position: relative;
  height: 100vh;
  width: 100vw;  /* 确保宽度也是全屏 */
  overflow: hidden;
}

.video-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.video-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.video-slide.active {
  opacity: 1;
}

.video-slide video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-container {
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;  /* 添加居中对齐 */
  padding: 0 5%;
  background-color: rgba(0, 0, 0, 0.4);  /* 添加半透明黑色背景 */
  z-index: 1;
}

.text-center {
  text-align: center;
  max-width: 900px;  /* 控制文本最大宽度 */
  padding: 2rem;
}

h1 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 2rem;
  color: #ffffff;
  line-height: 1.3;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

p {
  font-size: 1.2rem;
  line-height: 1.8;
  margin-bottom: 2.5rem;
  color: #ffffff;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
}

.btn-primary {
  font-size: 1.2rem;
  padding: 1rem 2.5rem;
  background-color: #0088cc;
  border: none;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #006699;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  h1 {
    font-size: 2.5rem;
  }
  
  p {
    font-size: 1.1rem;
  }
}
</style>